(function (doc) {
  function initialise() {
    doc.querySelectorAll('[data-benefit-preview-label]').forEach(function (copy) {
      var popup = copy.closest('.benefits-Popover');
      if (!popup || popup.dataset.benefitCopyReady) return;
      popup.dataset.benefitCopyReady = 'true';
      popup.classList.add('benefits-Popover--copy-preview');
      var trigger = doc.getElementById(popup.getAttribute('aria-labelledby'));
      if (trigger) {
        trigger.textContent = copy.dataset.benefitPreviewLabel;
        var icon = trigger.parentElement.querySelector('.product-benefit-image');
        if (icon) icon.alt = copy.dataset.benefitPreviewLabel;
      }
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', initialise, {once: true});
  else initialise();
  doc.addEventListener('shopify:section:load', initialise);
})(document);
